export const TABLE_VARIANTS = {
  PRACTITIONER: "practitioner",
  PATIENT: "patient",
};

export const COLUMN_IDS = {
  CLIENT: "client",
  APPOINTMENT: "appointment",
  PRACTITIONER: "practitioner",
  DATE_TIME: "dateTime",
  APPOINTMENT_TYPE: "appointmentType",
  DURATION: "duration",
  PAYMENT_STATUS: "paymentStatus",
  STATUS: "status",
  ACTIONS: "actions",
};

export const COLUMNS_CONFIG = {
  [TABLE_VARIANTS.PRACTITIONER]: [
    { id: COLUMN_IDS.CLIENT, label: "Client Name" },
    { id: COLUMN_IDS.DATE_TIME, label: "Date & Time" },
    { id: COLUMN_IDS.APPOINTMENT_TYPE, label: "Session Type" },
    { id: COLUMN_IDS.DURATION, label: "Duration" },
    { id: COLUMN_IDS.PAYMENT_STATUS, label: "Payment Status" },
    { id: COLUMN_IDS.STATUS, label: "Status" },
    { id: COLUMN_IDS.ACTIONS, label: "Actions" },
  ],
  [TABLE_VARIANTS.PATIENT]: [
    { id: COLUMN_IDS.APPOINTMENT, label: "Session" },
    { id: COLUMN_IDS.PRACTITIONER, label: "Practitioner" },
    { id: COLUMN_IDS.STATUS, label: "Status" },
    { id: COLUMN_IDS.ACTIONS, label: "Actions" },
  ],
};

export const BOOK_FOLLOW_UP_LABEL = "Schedule Follow-up";
export const RESCHEDULE_LABEL = "Reschedule";
export const CANCEL_LABEL = "Cancel";

export const APPOINTMENT_TYPE_LABELS = {
  FREE_CONSULTATION: "Free Consultation",
  FOLLOW_UP: "Follow-up",
};

export const CONSULTATION_REQUIRED_TOOLTIP =
  "Complete your free consultation first to unlock follow-up scheduling.";

export const AGREEMENT_REQUIRED_TOOLTIP =
  "Please sign the Client Participation Agreement before booking follow-up sessions.";

export const TELEHEALTH_CONSENT_REQUIRED_TOOLTIP =
  "Please sign the Telehealth Informed Consent before booking follow-up sessions.";

export const CANCEL_CONFIRM = {
  TITLE: "Cancel Session",
  MESSAGE: "Are you sure you want to cancel this session? This action cannot be undone.",
  CONFIRM: "Yes, Cancel",
  DISMISS: "Keep Session",
};
